var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToxifreeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 104,
    viewBox: "0 0 110 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 105.357,
    height: 100,
    rx: 14.2857,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.10714,
    y: 1.10714,
    width: 107.143,
    height: 101.786,
    rx: 15.1786,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.78571
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.3994,
    y: 87.7086,
    width: 44.1176,
    height: 26.2605,
    rx: 13.1303,
    transform: "rotate(-180 63.3994 87.7086)",
    fill: "#22CA51"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.708,
    y: 43.5889,
    width: 44.1176,
    height: 26.2605,
    rx: 13.1303,
    transform: "rotate(90 90.708 43.5889)",
    fill: "#5498EE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.582,
    y: 16.2801,
    width: 44.1176,
    height: 26.2605,
    rx: 13.1303,
    fill: "#22CA51"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45.542,
    y: 16.2801,
    width: 44.1176,
    height: 26.2605,
    rx: 13.1303,
    transform: "rotate(90 45.542 16.2801)",
    fill: "#5498EE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToxifreeIcon);
export default __webpack_public_path__ + "static/media/toxifree-icon.4acfc65687cbab18d9f0f71e43b2fa8a.svg";
export { ForwardRef as ReactComponent };